module.exports = __webpack_public_path__ + "static/media/lifeline_step_8.2c5868cf.png";